import React from 'react'
import { Button as TWButton } from '../../../../../components/Button'

export const Button = props => (
    <TWButton variantStyle="solid" variantColor="primary" type="submit">
        {props.children}
    </TWButton>
)
